import { Character } from "../../../domain/models/Character";
import { GenderHelper } from "../../../domain/models/Gender";

export class CharacterConverter {
  /**
   * Converts Firebase Realtime Database snapshot data to Character domain model.
   *
   * @param data The Firebase snapshot data from characters/<id>
   * @param identifier The character identifier (char_…)
   * @returns Character object or null if data is invalid
   */
  static fromFirebase(
    data: Record<string, any> | null | undefined,
    identifier: string,
  ): Character | null {
    if (!data || typeof data !== "object") {
      return null;
    }

    const profile = data.profile;
    if (!profile || typeof profile !== "object" || !profile.fullName) {
      return null;
    }

    const persona =
      data.persona && typeof data.persona === "object" ? data.persona : {};

    const vibeTags = Array.isArray(persona.vibeTags)
      ? persona.vibeTags.filter((tag: unknown) => typeof tag === "string")
      : [];

    return {
      identifier,
      fullName: profile.fullName,
      gender: GenderHelper.fromFirebaseValue(profile.gender),
      profilePhotoURL:
        typeof profile.profilePhotoURL === "string" &&
        profile.profilePhotoURL.length > 0
          ? profile.profilePhotoURL
          : undefined,
      faceCenteredProfilePhotoURL:
        typeof profile.faceCenteredProfilePhotoURL === "string" &&
        profile.faceCenteredProfilePhotoURL.length > 0
          ? profile.faceCenteredProfilePhotoURL
          : undefined,
      isActive: profile.isActive ?? false,
      archetype: typeof persona.archetype === "string" ? persona.archetype : "",
      shortBio: typeof persona.shortBio === "string" ? persona.shortBio : "",
      vibeTags,
    };
  }
}
